import React from 'react';

import { CircularProgress, InputAdornment, TextField } from '@material-ui/core';

const CustomTextField = ({ field, form, loading, readOnly = false, maxLength = 255, ...other }) => {
  return (
    <TextField
      variant="filled"
      fullWidth
      InputLabelProps={{ shrink: true }}
      name={field.name}
      {...field}
      error={Boolean(form.errors[field.name]) && form.touched[field.name]}
      helperText={form.touched[field.name] && form.errors[field.name]}
      InputProps={
        loading
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <CircularProgress size={16} />
                </InputAdornment>
              ),
            }
          : {
              readOnly: readOnly,
            }
      }
      inputProps={{
        maxLength: maxLength,
      }}
      {...other}
    />
  );
};

export default CustomTextField;
